import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { ConfirmationService } from 'primeng/api';
import { HttpRequestService } from '../../services/http-request.service';
import { Utils } from '../../services/utils.service';
import { FileUploadService } from './file-upload.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  uploadedFiles: any[] = [];
  @Input() configs: object;
  @Output() afterUpload = new EventEmitter();
  uploadConfigs: any;
  isCustomUpload: boolean = true;

  constructor(private appConfig: AppConfigService,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utils: Utils,
    private confirmationService: ConfirmationService,
    private fileUploadService: FileUploadService,
    private httpService: HttpRequestService) { }

  onUpload(file: any) {
    if (!file['files'].length) {
      return;
    }
    if (this.uploadConfigs.isMultiple) {
      // this.uploadedFiles.push(...file.);
    } else {
      this.uploadedFiles.push(...file.files);
    }
    this.fileUploadService.onUploadComplete.next(file);
    if (!this.fileUploadService.configs['isMultiple']) {
      this.ref.close({ file: this.uploadConfigs.isMultiple ? this.uploadedFiles : file, comScope: this.fileUploadService.scope });
    }
  }

  docUpload(event) {
    console.log(event);
  }

  onFinishedUpload() {
    this.ref.close(this.uploadedFiles);
  }

  onSelectFileUpload($event) {
    console.log($event);
  }

  onUploadHandler(event: any) {
    const prom:Observable<any>[] = [];
    let msg;
    event.files.forEach((element: File) => {
      // prom.push(this.httpService.fileUpload(element, this.uploadConfigs.uploadAPI.url));
      prom.push(this.httpService.fileUpload(element));
    });
    forkJoin(prom).subscribe({
      next: (value: any) => {
        this.uploadedFiles = value;
        msg = value[0].body.Success;
        this.confirmationService.confirm({
          message: (msg || value[0].body.Failure),
          header: 'Success',
          icon: 'fa fa-check-circle',
          acceptLabel: 'OK',
          rejectVisible: false,
        });
      },
      complete: () => {
        this.fileUploadService.onUploadComplete.next(this.uploadedFiles);
        // this.ref.close({ file: this.uploadedFiles, comScope: this.fileUploadService.scope });
        if (this.config.hasOwnProperty('data') && this.config.data.configs['vehicle']) {
           this.ref.close({ file: this.uploadedFiles, comScope: this.config.data.scope });
        }
        else if (!this.fileUploadService.configs['isMultiple']) {
            this.ref.close({ file: this.uploadedFiles, comScope: this.fileUploadService.scope });
        }
      }
    })
  }

  ngOnInit() {
    if(this.config && this.config.data) {
      if(this.config.data.isCustomUpload != null && this.config.data.isCustomUpload != undefined){
        this.isCustomUpload = this.config.data.isCustomUpload;
      }
    }
    
    let url;
    if(this.config.hasOwnProperty('data') && this.config.data.url){
      url = this.config.data.url
    }
    else{
      url = this.fileUploadService['url']
    }
    this.uploadConfigs = {
      uploadAPI: {
        // url: this.appConfig.appBaseUrl['fileUpload'] +  url,
        url: "/fileUpload" +  url,
      },
      maxUploadSize: this.fileUploadService.configs['maxFileSize'] ? this.fileUploadService.configs['maxFileSize'] : '2 MB'
    };
    this.uploadConfigs = { ...this.uploadConfigs, ...this.fileUploadService.configs };
  }

}
